import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { CategoryFormComponent } from './category-form/category-form.component';
import { CollectionFormComponent } from './collection-form/collection-form.component';
import { ChannelFormComponent } from './channel-form/channel-form.component';
import { ExportChannelComponent } from './export-channel/export-channel.component';
import { TaxonomyModule } from '@app/modules/taxonomy/taxonomy.module';
import { BasicSettingsComponent } from './channel-form/basic-settings/basic-settings.component';
import { DistributionSettingsComponent } from './channel-form/distribution-settings/ditribution-settings.component';
import { NewsletterSettingsComponent } from './channel-form/newsletter-settings/newsletter-settings.component';
import { IntegrationsSettingsComponent } from './channel-form/integrations-settings/integrations-settings.component';

@NgModule({
    declarations: [
        CategoryFormComponent,
        CollectionFormComponent,
        ChannelFormComponent,
        ExportChannelComponent,
        BasicSettingsComponent,
        DistributionSettingsComponent,
        NewsletterSettingsComponent,
    ],
    imports: [CommonModule, SharedModule, TaxonomyModule, IntegrationsSettingsComponent],
    exports: [CategoryFormComponent, CollectionFormComponent, ChannelFormComponent, ExportChannelComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageChannelsModule {}
